import { useDownloadAttachment } from "@ext/agent/components/hooks/useDownloadAttachment";
import { FileAttachmentTile } from "@ext/agent/components/panel/FileAttachmentTile";
import type { ChatAttachment } from "@ext/agent/core/attachmentStore";

export const SentFileAttachment = ({ attachment }: { attachment: ChatAttachment }) => {
	const { download, isDownloading } = useDownloadAttachment(attachment);
	return (
		<FileAttachmentTile
			isDownloading={isDownloading}
			mime={attachment.mime}
			name={attachment.originalFilename}
			onDownload={download}
		/>
	);
};
